import { StoredReferenceNumber } from "src/app/storage/models/stored-orders/stored-reference-number";

/**
 * An instance of the StoredReferenceNumber model to be used for schema validation
 */
export const storedReferenceNumberInstance: StoredReferenceNumber = {
	Number: "",
	Type: ""
}